module.exports = __webpack_public_path__ + "img/bbdc-4.2e741c55.jpg";